export default "__VITE_ASSET__cAMv045r__"